import { render, staticRenderFns } from "./EducationMyTest.vue?vue&type=template&id=b52d2d42&"
import script from "./EducationMyTest.vue?vue&type=script&lang=js&"
export * from "./EducationMyTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports